export enum MarkerType {
  Normal = 'Normal', // 일반주차장
  NormalCurrentFree = 'NormalCurrentFree', // 일반주차장(현재무료)
  NormalAlwaysFree = 'NormalAlwaysFree', // 일반주차장(상시무료)
  NormalDisabled = 'NormalDisabled', // 일반주차장(비활성화)
  NormalNoPriceInfo = 'NormalNoPriceInfo', // 일반주차장(가격정보없음)
  PartnerWithTicket = 'PartnerWithTicket', // 제휴주차장(티켓있음)
  PartnerWithTicketDisabled = 'PartnerWithTicketDisabled', // 제휴주차장(티켓있음, 비활성화)
  PartnerWithoutTicket = 'PartnerWithoutTicket', // 제휴주차장(티켓없음)
  Sharing = 'Sharing' // 공유주차장
}

export enum HASH_KEY_TYPE {
  IS_SALE = 'fsa',
  SHEET = 'sheet',
  ZOOM = 'zoom'
  // IS_ONLY_PARTNER = 'fpa',
  // IS_SHARE = 'fsh'
}
